import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginUseCase } from '../application/loginUseCase';
import { IsAuthenticatedUseCase } from '../application/isAuthenticatedUseCase';
import { redirectToMainApp } from '../../../shared/lib/mainAppUrl';
import * as S from './LoginPage.styles';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const hasAttemptedLoginRef = useRef(false);
  const loginUseCaseRef = useRef(new LoginUseCase());
  const isAuthenticatedUseCaseRef = useRef(new IsAuthenticatedUseCase());

  const [error, setError] = useState('');
  const [statusText, setStatusText] = useState('Проверяю SSO-сессию...');

  useEffect(() => {
    if (isAuthenticatedUseCaseRef.current.execute()) {
      navigate('/', { replace: true });
      return;
    }

    if (hasAttemptedLoginRef.current) {
      return;
    }
    hasAttemptedLoginRef.current = true;

    let cancelled = false;

    const runSsoLogin = async () => {
      setError('');
      setStatusText('Проверяю SSO-сессию...');

      let result: { success: boolean; error?: string; status?: number };
      try {
        result = await loginUseCaseRef.current.execute({ email: '', password: '' });
      } catch {
        result = {
          success: false,
          error: 'Не удалось подтвердить SSO-сессию',
        };
      }

      if (cancelled) {
        return;
      }

      if (result.success) {
        navigate('/', { replace: true });
        return;
      }

      // setStatusText('Не удалось выполнить SSO-вход. Перенаправляю в app.hudle.ru...');
      // setError('');
      // redirectToMainApp();

      console.log(result.success);
      console.log(result)
    };

    void runSsoLogin();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <S.LoginPageContainer>
      <S.LoginPageCard>
        <S.LoginPageTitle>Вход в CRM</S.LoginPageTitle>
        <S.LoginPageInfo>
          Выполняется авторизация
        </S.LoginPageInfo>
        <S.LoginPageStatus>{statusText}</S.LoginPageStatus>
        {error && <S.LoginPageError>{error}</S.LoginPageError>}
      </S.LoginPageCard>
    </S.LoginPageContainer>
  );
};
